import * as React from 'react';
// @ts-ignore
import AuthActions from 'auth/AuthActions';
import { FormattedMessage } from 'react-intl';
import Glyph from 'components/Glyph';
import LayerTrigger from 'components/LayerTrigger';
import LinkConstants from 'constants/LinkConstants';
import MenuItem from 'components/MenuItem';
import ModalMenuItem from 'components/ModalMenuItem';
import NavigationMenu from 'components/NavigationMenu';
// @ts-ignore
import InviteModal from 'users/components/InviteModal';
// @ts-ignore
import SupportDialog from 'support/components/SupportDialog';
// @ts-ignore
import TextAppLinkDialog from 'user/components/TextAppLinkDialog';

type Props = {
  showRCE?: boolean;
  children?: React.ReactNode;
};

class UserNavigationMenu extends React.Component<Props> {
  signOut = () => AuthActions.signOut();

  render() {
    const { children, showRCE } = this.props;

    const menu = (
      <NavigationMenu>
        <MenuItem
          menuKey="settings"
          to="/settings"
          eventElementName="Navigation-account"
          color="thunder">
          <Glyph name="avatar" size="large" />
          <FormattedMessage id="navigation.settings" defaultMessage="Account settings" />
        </MenuItem>
        {showRCE && (
          <MenuItem
            menuKey="rce"
            href={LinkConstants.COMMUNITY}
            target="_blank"
            eventElementName="Navigation-rce"
            color="thunder">
            <Glyph name="apple" size="large" />
            <FormattedMessage id="navigation.rce" defaultMessage="Connected Educator" />
          </MenuItem>
        )}
        <ModalMenuItem menuKey="help" modal={<SupportDialog />}>
          <Glyph name="help" size="large" />
          <FormattedMessage id="navigation.getTheApp" defaultMessage="Help center" />
        </ModalMenuItem>
        <ModalMenuItem menuKey="share" modal={<InviteModal />}>
          <Glyph name="heart" size="large" />
          <FormattedMessage id="navigation.getTheApp" defaultMessage="Share Remind" />
        </ModalMenuItem>
        <ModalMenuItem menuKey="get-app" modal={<TextAppLinkDialog />}>
          <Glyph name="mobile" size="large" />
          <FormattedMessage id="navigation.getTheApp" defaultMessage="Get the Remind app" />
        </ModalMenuItem>
        <MenuItem
          menuKey="logout"
          onClick={this.signOut}
          eventElementName="Navigation-logOut"
          color="thunder">
          <Glyph name="sign-out" size="large" />
          <FormattedMessage id="navigation.logout" defaultMessage="Log out" />
        </MenuItem>
      </NavigationMenu>
    );

    return (
      <LayerTrigger layer={menu} placement="bottom" trigger="click">
        {children || null}
      </LayerTrigger>
    );
  }
}

export default UserNavigationMenu;
